import { Card, Typography } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export function KpiCard({
  label,
  value,
  deltaPercent,
  tone = 'neutral',
}: {
  label: string;
  value: string;
  deltaPercent?: number | null;
  tone?: 'neutral' | 'good' | 'bad';
}) {
  const { t } = useTranslation();
  const color = tone === 'good' ? '#16a34a' : tone === 'bad' ? '#dc2626' : '#0f172a';
  const hasDelta = deltaPercent !== null && deltaPercent !== undefined;
  const up = (deltaPercent ?? 0) >= 0;
  return (
    <Card bodyStyle={{ padding: 16 }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>{label}</Typography.Text>
      <Typography.Title level={3} style={{ margin: '4px 0 0', color }}>{value}</Typography.Title>
      {hasDelta && (
        <Typography.Text style={{ fontSize: 12, color: up ? '#16a34a' : '#dc2626' }}>
          {up ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {Math.abs(deltaPercent!)}% · {t('owner.vsPrev')}
        </Typography.Text>
      )}
    </Card>
  );
}
